





































































import SimpleMap from '../../core/components/SimpleMap.vue';
import ModalIgnorePeriod from './ModalIgnorePeriod.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getDateFromTimestamp,
    getIdsFromList,
    removeItemsFromList,
    matchedIndexIdInArray,
    getUniqueId,
    formatDate,
    downloadFile,
    getDateFromDateFormatApi,
    getMinDateFromList,
    getMaxDateFromList,
    getIndexFromList
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import DatePickerRange from '../../core/components/DatePickerRange.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Button from '../../core/components/Button.vue';
import {
    booleanFormatter,
    formattedDate,
    getOnlyDateFromTimestamp,
    nullFormatter
} from '../../core/utils/table-formatters';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import {
    MsgBox,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import ModalCompanyHarvest from './ModalCompanyHarvest.vue';
import ModalVehicleCalibration from './ModalVehicleCalibration.vue';
import { config } from 'rxjs';
import moment from 'moment';
import { dateFormat } from 'highcharts';

@Component({
    components: {
        Loading,
        Combobox,
        SimpleMap,
        DatePickerSingle,
        DatePickerRange,
        Button,
        SimpleTable,
        ModalIgnorePeriod,
        DeleteConfirmation
    }
})
export default class IgnoredPeriods extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    //delete confirmation
    confirmationDelete: boolean = false;
    loadingIgnoredPeriods: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';
    preselectedPeriods: null | object = null;

    @Prop({
        default() {
            return [];
        }
    })
    ignoredPeriodsList: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    vehiclesOptions: Array<object>;
    @Prop() vehicleID: number | null;
    @Prop({ default: false }) seeAll: boolean;
    @Prop({ default: false }) saveOnMemory: boolean;
    @Prop({ default: false }) disabledRow: boolean;
    patchData: object | null = null;
    visibleModalIgnorePeriod: boolean = false;
    periodToDelete: object | null = null;

    @Emit()
    viewAllIgnoredPeriods() {}

    @Emit()
    reloadModalViewAll() {}

    @Emit()
    disabledIgnoredPeriod(item) {
        return item;
    }

    preselectIgnoredPeriods(segments: Array<object>){
        let minDate = getMinDateFromList(segments, 'start');
        let maxDate = getMaxDateFromList(segments, 'end');
        let vehicles:Array<object> = [];

        for (let index = 0; index < segments.length; index++) {
            const segment = segments[index];
            let indexInVehiclesList = getIndexFromList(vehicles, 'id', segment['vehicle']['id'])
            if(indexInVehiclesList == -1){
                vehicles.push(segment['vehicle'])
            }
        }

        this.preselectedPeriods = {
            start: minDate,
            end: maxDate,
            vehicles: vehicles
        }
        this.visibilityModalIgnorePeriod(true);
    }

    get getHeaders() {
        let tableHeaders: Array<object> = [
            {
                text: 'Fecha Inicio',
                value: 'start_date',
                formatter: this.dateFormatter,
                sortable: true,
                width: '200px'
            },
            {
                text: 'Fecha Fin',
                value: 'end_date',
                formatter: this.dateFormatter,
                sortable: true,
                width: '200px'
            },
            {
                text: 'Cálculo area sin rendimiento',
                value: 'calculate_without_performance',
                align: 'center',
                sortable: true,
                formatter: booleanFormatter
            },
            {
                text: 'Humedad descartada',
                value: 'discard_humidity',
                align: 'center',
                sortable: true,
                formatter: booleanFormatter
            },
            {
                text: 'Humedad descartada CSV',
                value: 'discard_humidity_csv',
                align: 'center',
                sortable: true,
                formatter: booleanFormatter
            },
            {
                text: 'Rendimiento descartado',
                value: 'discard_performance',
                align: 'center',
                sortable: true,
                formatter: booleanFormatter
            },
            {
                text: 'Rendimiento descartado CSV',
                value: 'discard_performance_csv',
                align: 'center',
                sortable: true,
                formatter: booleanFormatter
            },
            {
                text: 'Segmento descartado',
                value: 'discard_segment',
                align: 'center',
                sortable: true,
                formatter: booleanFormatter
            },
            {
                text: 'Acciones',
                value: 'actions',
                sortable: true
            }
        ];

        if (this.vehicleID == -1) {
            tableHeaders.unshift({
                text: 'Vehículo',
                value: 'vehicle',
                align: 'center',
                sortable: true
            });
        }

        return tableHeaders;
    }

    editSelectedPeriod(item) {
        this.preselectedPeriods = null;
        this.patchData = item;
        this.visibilityModalIgnorePeriod(true);
    }

    deleteSelectedPeriod(item) {
        this.periodToDelete = item;

        this.showDeleteConfirmationDialog('Eliminar período ignorado', '¿Está seguro que desea eliminar este período');
    }

    deleteAction(value) {
        if (value) {
            this.confirmationDelete = false;
            if (!this.saveOnMemory) {
                this.deletePeriod();
            } else {
                this.ignoredPeriodsList = removeItemsFromList(this.ignoredPeriodsList, [this.periodToDelete], 'id');
            }
        } else {
            this.confirmationDelete = false;
        }
    }

    deletePeriod() {
        let self = this;
        if (this.periodToDelete !== null) {
            this.loadingIgnoredPeriods = true;
            InsuranceServices.deleteIgnorePeriod(this.periodToDelete['id'])
                .then(response => {
                    let msg = '';
                    if (response && response.data && response.data.message) {
                        msg = response.data.message;
                    } else {
                        msg = 'Período Eliminado con éxito';
                    }
                    this.loadingIgnoredPeriods = false;
                    this.$_successDeleteRecipients(msg);
                    this.ignoredPeriodsList = removeItemsFromList(self.ignoredPeriodsList, [self.periodToDelete], 'id');
                    this.reloadModalViewAll();
                })
                .catch(error => {
                    this.loadingIgnoredPeriods = false;
                    this.showMsgError(error);
                });
        }
    }

    showMsgError(error) {
        let self = this;
        let msg = '';
        if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message;
        } else {
            msg = 'Ocurrió un error';
        }
        this.$_errorAddFilter(msg);
    }

    showDeleteConfirmationDialog(title, msgBody) {
        this.deleteModalTitle = title;
        this.deleteBody = msgBody;
        this.confirmationDelete = true;
    }

    dateFormatter(value) {
        return formattedDate(value, true);
    }

    visibilityModalIgnorePeriod(value) {
        this.visibleModalIgnorePeriod = value;
    }

    closeModalIgnorePeriod() {
        this.patchData = null;
        this.periodToDelete = null;
        this.visibilityModalIgnorePeriod(false);
    }

    clickAddNewIgnoredPeriod() {
        this.preselectedPeriods = null;
        this.patchData = null;
        this.periodToDelete = null;
        this.visibilityModalIgnorePeriod(true);
    }

    addNewIgnoredPeriodTolist(newPeriod) {
        // console.log("addNewIgnoredPeriodTolist", newPeriod);
        this.ignoredPeriodsList.push(newPeriod);
    }

    updateIgnoredPeriodInList(updatedPeriod) {
        let indexToUpdate = matchedIndexIdInArray(this.ignoredPeriodsList, updatedPeriod['id']);
        if (indexToUpdate !== -1) {
            this.$set(
                this.ignoredPeriodsList[indexToUpdate],
                'calculate_without_performance',
                updatedPeriod['calculate_without_performance']
            );
            this.$set(this.ignoredPeriodsList[indexToUpdate], 'discard_humidity', updatedPeriod['discard_humidity']);
            this.$set(
                this.ignoredPeriodsList[indexToUpdate],
                'discard_humidity_csv',
                updatedPeriod['discard_humidity_csv']
            );
            this.$set(
                this.ignoredPeriodsList[indexToUpdate],
                'discard_performance',
                updatedPeriod['discard_performance']
            );
            this.$set(
                this.ignoredPeriodsList[indexToUpdate],
                'discard_performance_csv',
                updatedPeriod['discard_performance_csv']
            );
            this.$set(this.ignoredPeriodsList[indexToUpdate], 'discard_segment', updatedPeriod['discard_segment']);
            this.$set(this.ignoredPeriodsList[indexToUpdate], 'end_date', updatedPeriod['end_date']);
            this.$set(this.ignoredPeriodsList[indexToUpdate], 'start_date', updatedPeriod['start_date']);
        }
        this.reloadModalViewAll();
    }
}
